export const debug = process.env.NODE_ENV === "development";

export const getApi = () => process.env.React_App_API || "/";

export async function sleep() {
  const seconds = Math.floor(Math.random() * (50 - 10 + 1)) + 10;
  return new Promise((resolve) => {
    setTimeout(resolve, seconds * 1000);
  });
}
